import React, { useEffect, useState } from "react";
import Banner from "../../../common/components/Banner";
import DiscoverProduct from "./components/DiscoverProducts";
import Collections from "@common/components/Collections";
import SectionBanner from "../../../common/components/SectionBanner";
import Instafeed from "./components/InstafeedContainer";
import clientlogo from "../../../common/assets/json/client.json";
import { Link } from "react-router-dom";
import Favourites from "@pages/Shop/view/components/Favourites";
import { categoryList } from "@common/utils/constant";
import apiUrl from "@common/utils/apiURL";
import useApi from "@common/utils/useApi";
// import { getWishlist } from '@common/utils/cart';
import Endurance from "./components/Endurance";
import { Modal, Box } from "@mui/material";
import unlockImage from "@assets/images/icons/lock.svg";
import { openSignInModal } from "store/slices/authSlice";
import { useDispatch } from "react-redux";
import CommonUnlockModal from "@common/components/CommonUnlockModal";
import { resetPreSelectedFilters } from "@common/utils/utils";
import { getAuthToken, isUserLoggedIn } from "@common/utils/auth/authService";
import { useLocation } from "react-router-dom";

import SeoContainer from "@common/components/SeoContainer";
import { trackCriteoEvent } from "utils/criteo";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import required modules
import { Navigation, Pagination, Autoplay } from "swiper/modules";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

function Home() {
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoggedIn = isUserLoggedIn(); // Check if the user is logged in


  async function fetchProducts() {
    const url = "https://shopify-backend-zykw.onrender.com/api/featured-products";
    try {
      const response = await fetch(url, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const { products } = await response.json();

      const isBestSeller = (p) => {
        const t = p?.tags?.toLowerCase();
        return t.includes('best sellers') || t.includes('bestseller');
      };

      const transform = (products = []) =>
        products
          .filter(isBestSeller)
          .map(({ id, url, title, image, price }) => ({
            id,
            slug: url,
            thumbnailImageUrl: image,
            name: title,
            price: price,
          }))
          .slice(0, 6)

      const result = transform(products);
      return result;
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  }
  const [featuredProducts, setFeaturedProducts] = useState([]);
  useEffect(() => {
    const loadProducts = async () => {
      const data = await fetchProducts();
      setFeaturedProducts(data || []);
    };
    loadProducts();
  }, []);

  const handleBackdropClick = (event) => {
    event.stopPropagation();
  };

  const [openUnlockModal, setOpenUnlockModal] = React.useState(false);
  // const handleOpenUnlockModal = () => setOpenUnlockModal(true);

  const handleCloseUnlockModal = () => {
    setOpenUnlockModal(false);
    localStorage.setItem("hasSeenUnlockModal", "true");
  };

  // Check if the modal should be shown
  useEffect(() => {
    const hasSeenModal = localStorage.getItem("hasSeenUnlockModal"); // Check if the modal has already been shown

    if (!isLoggedIn && !hasSeenModal) {
      setTimeout(() => {
        setOpenUnlockModal(false);
      }, 5000); // Show the modal after 5 seconds
    }
  }, [isLoggedIn]);

  useEffect(() => {
    let email = null;
    const userInfo = JSON.parse(localStorage.getItem("u_info"), null);
    // console.log({ userInfo });

    if (!!userInfo && !userInfo?.firstName?.includes("Guest")) {
      email = userInfo?.email;
    } else {
      email = "GuestUser";
    }
    trackCriteoEvent([
      { event: "viewHome" },
      // { event: "setEmail", email },
    ]);
    console.log("criteo event");
  }, []);

  return (
    <>
      {/* <SeoContainer
                title={seoData.title}
                description={seoData.description}
                keywords={seoData.keywords.join(', ')}
                ogTitle={seoData.ogTitle}
                ogDescription={seoData.ogDescription}
                ogImage={seoData.ogImage}
                ogUrl={seoData.ogUrl}
            /> */}
      {/* Banner component now uses type from CMS backend */}
      <Banner hideText />
      <div className="bs-section bs-section--typ-grey">
        <div className="bs-section__section-cont">
          <h2 className="bs-section__title">about sansaar</h2>
          <p className="bs-section__desc">
            At Sansaar, each fabric we create embodies a journey of meticulous
            craftsmanship and modern sustainability. Inspired by mindful living,
            we’ve embedded sustainability at every step of the way. From ethical
            sourcing to the final product, weaving a promise of a better
            tomorrow for you and your loved ones.
          </p>
          <div className="lyt-features">
            <div className="mod-icon-info">
              <div className="mod-icon-info__icon-wrap">
                <span className="icon icon-non-toxic"></span>
              </div>
              <div className="mod-icon-info__info-wrap">
                <p className="mod-icon-info__desc">
                  Safe &<span className="cm-line-break">Non-Toxic</span>
                </p>
              </div>
            </div>
            <div className="mod-icon-info">
              <div className="mod-icon-info__icon-wrap">
                <span className="icon icon-sustainably"></span>
              </div>
              <div className="mod-icon-info__info-wrap">
                <p className="mod-icon-info__desc">
                  Sustainable
                  <span className="cm-line-break">Management Practices</span>
                </p>
              </div>
            </div>
            <div className="mod-icon-info">
              <div className="mod-icon-info__icon-wrap">
                <span className="icon icon-washable"></span>
              </div>
              <div className="mod-icon-info__info-wrap">
                <p className="mod-icon-info__desc">
                  Washable &<span className="cm-line-break">Resilient</span>
                </p>
              </div>
            </div>
            <div className="mod-icon-info">
              <div className="mod-icon-info__icon-wrap">
                <span className="icon icon-touch"></span>
              </div>
              <div className="mod-icon-info__info-wrap">
                <p className="mod-icon-info__desc">
                  Exceptional
                  <span className="cm-line-break">Touch</span>
                </p>
              </div>
            </div>
            <div className="mod-icon-info">
              <div className="mod-icon-info__icon-wrap">
                <span className="icon icon-quality"></span>
              </div>
              <div className="mod-icon-info__info-wrap">
                <p className="mod-icon-info__desc">
                  Certified
                  <span className="cm-line-break">Quality</span>
                </p>
              </div>
            </div>
            <div className="mod-icon-info">
              <div className="mod-icon-info__icon-wrap">
                <span className="icon icon-social"></span>
              </div>
              <div className="mod-icon-info__info-wrap">
                <p className="mod-icon-info__desc">
                  Social
                  <span className="cm-line-break">Responsibility</span>
                </p>
              </div>
            </div>
          </div>
          <Link
            to="/our-journey"
            className="bs-btn bs-btn__btn-solid bs-btn__btn-solid--inverse d-none"
          >
            learn more
          </Link>
        </div>
      </div>
      <div className="bs-section">
        <div className="bs-section__section-head">
          <h2 className="bs-section__title">discover</h2>
        </div>
        <div className="bs-section__section-cont">
          {/* Desktop Layout */}
          <ul className="lyt-discover lyt-discover--desktop">
            <li className="lyt-discover__item">
              <DiscoverProduct
                title="curtains"
                imgUrl="240229-DE-03_gkp5gh.jpg"
                link="/collections?type=endUse&value=Curtain"
              />
            </li>
            <li className="lyt-discover__item">
              <DiscoverProduct
                title="multipurpose"
                imgUrl="Rectangle_2_dpuksx.jpg"
                link="/collections?type=endUse&value=Multipurpose"
              />
            </li>
            <li className="lyt-discover__item">
              <DiscoverProduct
                title="upholstery"
                imgUrl="_A1_1529_dpqecm.jpg"
                link="/collections?type=endUse&value=Upholstery"
              />
            </li>
          </ul>

          {/* Mobile Swiper Layout */}
          <div className="lyt-discover--mobile" style={{
            paddingBottom: "0px"
          }}>
            <Swiper
              grabCursor={true}
              slidesPerView="auto"
              spaceBetween={24}
              modules={[Navigation, Pagination, Autoplay]}
              className="lyt-discover__swiper-container"
              centeredSlides={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              speed={1000}
              loop={true}
              style={{
                paddingBottom: "0px"
              }}
            >
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="curtains"
                  imgUrl="240229-DE-03_gkp5gh.jpg"
                  link="/collections?type=endUse&value=Curtain"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="multipurpose"
                  imgUrl="Rectangle_2_dpuksx.jpg"
                  link="/collections?type=endUse&value=Multipurpose"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="upholstery"
                  imgUrl="_A1_1529_dpqecm.jpg"
                  link="/collections?type=endUse&value=Upholstery"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="curtains"
                  imgUrl="240229-DE-03_gkp5gh.jpg"
                  link="/collections?type=endUse&value=Curtain"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="multipurpose"
                  imgUrl="Rectangle_2_dpuksx.jpg"
                  link="/collections?type=endUse&value=Multipurpose"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="upholstery"
                  imgUrl="_A1_1529_dpqecm.jpg"
                  link="/collections?type=endUse&value=Upholstery"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="curtains"
                  imgUrl="240229-DE-03_gkp5gh.jpg"
                  link="/collections?type=endUse&value=Curtain"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="multipurpose"
                  imgUrl="Rectangle_2_dpuksx.jpg"
                  link="/collections?type=endUse&value=Multipurpose"
                />
              </SwiperSlide>
              <SwiperSlide className="lyt-discover__swiper-slide">
                <DiscoverProduct
                  title="upholstery"
                  imgUrl="_A1_1529_dpqecm.jpg"
                  link="/collections?type=endUse&value=Upholstery"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
      <div className="bs-section bs-section--products">
        <div className="bs-section__section-head">
          <h2 className="bs-section__title">Explore our range of Bedding</h2>
          <p className="bs-section__sub-title">Embrace CONSCIOUS LUXURY</p>
          <ul className="bs-section__more-info-list">
            {categoryList.map((item, index) => (
              <li className="bs-section__more-info-item" key={index}>
                <Link
                  to={item.link}
                  onClick={(e) => {
                    resetPreSelectedFilters();
                    localStorage.setItem("filterValue", item.name);
                    localStorage.setItem("filterKey", "category");
                  }}
                  className="mod-product-tag mod-product-tag--outline bs-section__more-info-item__tag"
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="bs-section__section-cont">
          <SectionBanner
            variant="typ-display-link"
            imageUrl="Explore-Our-Bedding-Range"
            redirectionLink="/products"
          />
        </div>
      </div>
      <div className="bs-section bs-section--typ-grey cm-overflow-hidden">
        <div className="bs-section__section-head">
          <h2 className="bs-section__title">TRENDING FABRIC COLLECTIONS</h2>
        </div>
        <div className="bs-section__section-cont">
          <Collections />
        </div>
      </div>
      {featuredProducts.length > 0 && (<div className="bs-section bs-section--typ-new-title cm-no-padding-horizontal">
        <div className="bs-section__section-head">
          <h2 className="bs-section__title">Featured Products</h2>
          <p className="bs-section__sub-title">Bedding, made just for you</p>
        </div>
        <div className="bs-section__section-cont">
          <Favourites
            gridGap={16}
            actionTitle="shop all products"
            data={featuredProducts}
            showAddToCart={false}
            autoplay={true}
          />
        </div>
      </div>)}
      <div className="bs-section bs-section--typ-grey">
        <div className="bs-section__section-cont">
          <Endurance />
        </div>
      </div>
      <div className="bs-section cm-no-padding">
        <div className="bs-section__section-cont">
          <SectionBanner
            imageUrl="home-1.jpg"
            title="weaving sustainability along the way"
            desc="Sustainability is the soul of Sansaar, a commitment woven into every fabric. It's about preserving the delicate balance of nature, empowering communities through ethical practices, and crafting fabrics that embody both beauty and responsibility."
            link="/sustainability"
          // clientlogo={clientlogo}
          />
        </div>
      </div>
      <div className="bs-section bs-section--typ-grey ">
        <div className="bs-section__section-head">
          <h2 className="bs-section__title">
            follow us{" "}
            <span className="bs-section__title--handle-id">
              @sansaar.ddecorbrand
            </span>
          </h2>
        </div>
        <div className="bs-section__section-cont">
          <Instafeed />
          <Link to={"/franchise-enquiry"} className="bs-btn bs-btn__btn-solid">
            Contact Us
          </Link>
        </div>
      </div>
      <Modal
        // open={true}
        open={openUnlockModal}
        onClose={handleCloseUnlockModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bs-modal bs-modal--typ-col"
      >
        <Box
          className="bs-modal__wrapper bs-banner-form"
          sx={style}
          onClick={handleBackdropClick}
        >
          <button
            className="bs-modal__close  bs-banner-form__close-btn"
            onClick={handleCloseUnlockModal}
          >
            <span className="icon icon-simple-close"></span>
          </button>
          <CommonUnlockModal
            classname="bs-banner-form__body"
            handleCloseUnlockModal={handleCloseUnlockModal}
            signInHandle={() => dispatch(openSignInModal())}
          />
        </Box>
      </Modal>
    </>
  );
}

export default Home;
